import Consts from "Interfaces/Consts";

interface Props {
    componentId: string;
    show: boolean;
    classForMsg: () => string;
    closeMsg: () => void;
}

const ContactUsError: React.FC<Props> = ({ componentId, show, classForMsg, closeMsg }) => {

    return <div id={`contact-error-${componentId}`}
        className={`mst-error-msg mx-auto text-center
        ${show ? 'd-block' : 'd-none'}
        ${classForMsg()}`
        }>

        <div className="center-line">

            <img id={`SendError-${componentId}`} src="/Images/Components/SendError.svg" alt="" />

            <div className="mst-msg-txt pt-3 mx-auto"> {Consts.sendErrorMsg} </div>

            <button className="mst-msg-btn pt-5" type="button" onClick={closeMsg}>
                {Consts.close}
            </button>

        </div>

    </div>
}

export default ContactUsError;